import PropTypes from "prop-types";
import React, { Component } from "react";
import { Grid, Box, CircularProgress, Button } from "@material-ui/core";
import { withRouter, Link as ReactRouterLink } from "react-router-dom";
import {
  Details as DetailsIcon,
  Description as DescriptionIcon,
  ErrorOutline as ErrorOutlineIcon,
  DateRange as DateRangeIcon,
  Phone as PhoneIcon,
  BarChart as ChartIcon
} from "@material-ui/icons";
import styled from "styled-components";
import HeaderProfile from "../../waybee-ui/HeaderProfile";
import MenuButton from "../../waybee-ui/MenuButton";

import StudentService from "../../services/StudentService";
import BackButton from "../../components/BackButton";
import { Can } from "../../acl/can";
import HoverPopover from "../../components/HoverPopover";

const Link = props => (
  <ReactRouterLink {...props} style={{ textDecoration: "none" }} />
);

const DisableItem = styled(Button)`
  background-color: #fff;
  color: ${({ theme }) => theme.color.default.dark};
  font-size: 25px;
  font-weight: 500;
  text-transform: none;
  height: 90px;
  border-radius: 6px;
  padding: 5px 23px;
  justify-content: flex-start;
  border: none;
  margin: 3px 0;
  svg {
    color: ${({ theme }) => theme.color.default.dark};
    margin-right: 10px;
    font-size: 32px !important;
  }
`;

class StudentProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      student: null
    };
  }

  componentDidMount() {
    this.getStudentProfile();
  }

  getStudentProfile = async () => {
    const { match } = this.props;
    const { studentId } = match.params;
    const student = await StudentService.getStudentById(studentId);
    this.setState({ student });
  };

  render() {
    // const { history } = this.props;
    const { student } = this.state;
    const studentClass = localStorage.getItem("class");

    if (!student) {
      return (
        <Box p={6} textAlign="center">
          <CircularProgress />
        </Box>
      );
    }

    return (
      <Grid container spacing={2}>
        <BackButton
          to={studentClass ? `/classes/${studentClass}` : "/classes"}
        />

        <Grid item xs={12}>
          <HeaderProfile
            name={student.name}
            info={`R.A: ${student.ra}`}
            photo={student.photo}
          />
        </Grid>
        <Grid item xs={12}>
          <Link to={`${student.id}/notes`}>
            <MenuButton icon={<DetailsIcon />}>Observações</MenuButton>
          </Link>
          {student.waybeeUserId ? (
            <>
              <Link to={`${student.id}/statistics`}>
                <MenuButton icon={<DescriptionIcon />}>Boletim</MenuButton>
              </Link>
              <Link to={`${student.id}/charts`}>
                <MenuButton icon={<ChartIcon />}>Gráficos</MenuButton>
              </Link>
            </>
          ) : (
            <>
              <HoverPopover
                id={1}
                value="Boletim não disponível pois o aluno não está cadastrado no app"
              >
                <DisableItem startIcon={<DescriptionIcon />} disabled fullWidth>
                  Boletim
                </DisableItem>
              </HoverPopover>
              <HoverPopover
                id={2}
                value="Boletim não disponível pois o aluno não está cadastrado no app"
              >
                <DisableItem startIcon={<ChartIcon />} disabled fullWidth>
                  Gráficos
                </DisableItem>
              </HoverPopover>
            </>
          )}

          <Link to={`${student.id}/occurrences`}>
            <MenuButton icon={<ErrorOutlineIcon />}>
              Histórico de Ocorrências
            </MenuButton>
          </Link>
          <Link to={`${student.id}/schedule`}>
            <MenuButton icon={<DateRangeIcon />}>Horários</MenuButton>
          </Link>
          <Can I="use module" a="studentContactInfo">
            <Link to={`${student.id}/contact`}>
              <MenuButton icon={<PhoneIcon />}>Contato</MenuButton>
            </Link>
          </Can>
        </Grid>
      </Grid>
    );
  }
}

StudentProfile.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.array
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.any
  }).isRequired
};
export default withRouter(StudentProfile);
